import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ReplaySubject, takeUntil } from 'rxjs';
import { CategoriesService } from 'src/app/services/categori.service';

@Component({
  standalone: false,
  selector: 'app-cancelled-orders',
  templateUrl: './cancelled-orders.component.html',
  styleUrls: ['./cancelled-orders.component.css'],
})
export class CancelledOrdersComponent implements OnInit {
  order_arr: any;
  showMessage = true;
  orders_global: any = [];

  page: number = 1;
  limit: number = 10;
  totalCount: number = 10;
  loading: boolean = false;
  allCancelledOrders: any;
  selectedRow: any;

  phoneNumberSearchKey: string | any = '';
  productNameSearchKey: string | any = '';
  paymentStatusValue: boolean | any;
  deliveryStatusValue: boolean | any;

  clientPhoneNumberValue: string = '';
  productNameValue: string = '';

  paymentStatusSelectModel: string = 'all';
  deliveryStatusSelectModel: string = 'all';

  displayedColumns: string[] = [
    '#',
    'username',
    'date',
    'packages',
    'status',
    'paid',
    'delivered',
    'cancelledReason',
    'totalPrice',
  ];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private rest: CategoriesService, private route: Router) {}

  ngOnInit() {
    this.getSessionStorageDate();
    this.rest.showSpinner();
    this.getAllCancelledOrders();
  }

  getAllCancelledOrders() {
    this.loading = true;
    this.rest
      .getFilteredOrdersService(
        this.page,
        this.limit,
        this.productNameSearchKey,
        this.phoneNumberSearchKey,
        true,
        this.paymentStatusValue,
        this.deliveryStatusValue
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe((res: any) => {
        this.rest.hideSpinner();
        this.loading = false;
        this.allCancelledOrders = res?.results;
        this.totalCount = res.total_count;
      });
  }

  changePage(e: PageEvent) {
    this.page = e.pageIndex + 1;
    this.getAllCancelledOrders();
  }

  orderDetails(id: any) {
    this.route.navigate(['main/order_details', id]);
    if (this.productNameSearchKey) {
      sessionStorage.setItem('orderProductSearchKey', this.productNameSearchKey);
    }
    if (this.phoneNumberSearchKey) {
      sessionStorage.setItem('orderClientPhoneNumber', this.phoneNumberSearchKey);
    }
    if (this.paymentStatusValue === true || this.paymentStatusValue === false) {
      sessionStorage.setItem('paymentStatus', this.paymentStatusValue);
    }
    if (this.deliveryStatusValue === true || this.deliveryStatusValue === false) {
      sessionStorage.setItem('deliveryStatus', this.deliveryStatusValue);
    }
    sessionStorage.setItem('pageNumber', this.page.toString());
  }

  phoneNumberSearch(phoneNumberSearchEvent: any) {
    this.page = 1;
    this.limit = 10;
    this.phoneNumberSearchKey = phoneNumberSearchEvent?.target?.value;
    this.getAllCancelledOrders();
  }

  productNameSearch(productNameSearchEvent: any) {
    this.page = 1;
    this.limit = 10;
    this.productNameSearchKey = productNameSearchEvent?.target?.value;
    this.getAllCancelledOrders();
  }

  paymentStatusFilter(value: any) {
    if (value == 'all') {
      this.paymentStatusValue = undefined;
    } else {
      this.paymentStatusValue = value;
    }
    this.getAllCancelledOrders();
  }

  deliveryStatusFilter(value: any) {
    if (value == 'all') {
      this.deliveryStatusValue = undefined;
    } else {
      this.deliveryStatusValue = value;
    }
    this.getAllCancelledOrders();
  }

  onRowHovered(row: any) {
    this.selectedRow = row;
  }

  handleMouseLeave() {
    this.selectedRow = false;
  }

  getSessionStorageDate() {
    this.productNameSearchKey = sessionStorage.getItem('orderProductSearchKey');
    sessionStorage.removeItem('orderProductSearchKey');
    this.productNameValue = this.productNameSearchKey;

    this.phoneNumberSearchKey = sessionStorage.getItem('orderClientPhoneNumber');
    sessionStorage.removeItem('orderClientPhoneNumber');
    this.clientPhoneNumberValue = this.phoneNumberSearchKey;

    const pageNumberStored = sessionStorage.getItem('pageNumber');
    if (pageNumberStored) {
      this.page = parseFloat(pageNumberStored);
    }
    sessionStorage.removeItem('pageNumber');

    const savedPayment = sessionStorage.getItem('paymentStatus');
    sessionStorage.removeItem('paymentStatus');
    if (savedPayment === 'true') {
      this.paymentStatusSelectModel = 'true';
      this.paymentStatusValue = true;
    } else if (savedPayment === 'false') {
      this.paymentStatusSelectModel = 'false';
      this.paymentStatusValue = false;
    }

    const savedDelivery = sessionStorage.getItem('deliveryStatus');
    sessionStorage.removeItem('deliveryStatus');
    if (savedDelivery === 'true') {
      this.deliveryStatusSelectModel = 'true';
      this.deliveryStatusValue = true;
    } else if (savedDelivery === 'false') {
      this.deliveryStatusSelectModel = 'false';
      this.deliveryStatusValue = false;
    }
  }
}
